/**
 * Wrapper minimo su @microsoft/teams-js v2.
 *
 * Fuori da Teams (`app.initialize()` non completa) si degrada in modalità
 * browser, così la pagina resta usabile e testabile.
 */
import { app } from '@microsoft/teams-js';

export interface TeamsContext {
  inTeams: boolean;
  userDisplayName: string | null;
  locale: string;
  theme: string;
}

export interface TeamsClient {
  context: TeamsContext;
  /** Apre l'URL nel browser di sistema, fuori dal frame di Teams. */
  openLink(url: string): Promise<void>;
  onThemeChange(handler: (theme: string) => void): void;
}

const standalone: TeamsContext = {
  inTeams: false,
  userDisplayName: null,
  locale: 'it-IT',
  theme: 'default',
};

export async function initTeams(): Promise<TeamsClient> {
  try {
    await app.initialize();
  } catch (err) {
    console.warn('[teams] initialize fallito, modalità browser:', err);
    return {
      context: standalone,
      openLink: async (url: string) => {
        window.open(url, '_blank', 'noopener');
      },
      onThemeChange: () => undefined,
    };
  }

  const ctx = await app.getContext();

  return {
    context: {
      inTeams: true,
      userDisplayName: ctx.user?.displayName ?? null,
      locale: ctx.app.locale || 'it-IT',
      theme: ctx.app.theme || 'default',
    },
    async openLink(url: string): Promise<void> {
      await app.openLink(url);
    },
    onThemeChange(handler: (theme: string) => void): void {
      app.registerOnThemeChangeHandler(handler);
    },
  };
}
